import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8e66eed8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8e66eed8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e66eed8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\dm\\longda\\web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e66eed8')) {
      api.createRecord('8e66eed8', component.options)
    } else {
      api.reload('8e66eed8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8e66eed8&scoped=true", function () {
      api.rerender('8e66eed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/Settings/index.vue"
export default component.exports